import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Card' })({
    root: {
        display: 'flex',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 40,
        boxSizing: 'border-box',
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.05)',
        border: '2px solid transparent',
        transition: 'all 0.2s',
        textDecoration: 'none',
        position: 'relative',
        zIndex: 1,
        // Hack to avoid slow render of huge shadow
        '&:before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'transparent',
            boxShadow: '0 0 96px 0 #A44025',
            zIndex: -1,
            transition: 'all 0.2s',
            opacity: 0,
            borderRadius: 'inherit',
            backdropFilter: 'blur(40px)'
        },
        '@media (hover: hover)': {
            '&:hover': {
                borderColor: '#FF8B61',
                background: 'rgba(255, 255, 255, 0.03)',
                '&:before': {
                    opacity: 1
                }
            }
        }
    },
    icon: {
        lineHeight: 0,
        width: 40,
        height: 40,
        '& > svg': {
            width: '100%',
            height: '100%'
        }
    },
    hint: {
        color: '#fff',
        fontSize: 18,
        fontWeight: 400,
        lineHeight: '160%'
    }
});
